export const BASE_URL = 'https://content.dev.shamsuperstore.com';
export const API_BASE_URL = 'https://content.dev.shamsuperstore.com';
export const MEDIA_BASE_URL = 'https://content.dev.shamsuperstore.com';
export const LOCATIONIQ_MAP_TILE_URL =
  'https://{s}-tiles.locationiq.com/v3/streets/r/{z}/{x}/{y}.png?key=pk.b0be52299835779ed734ae662c122926';
export const SELLER_DASH_URL = 'https://seller.dev.shamsuperstore.com';

// export const API_BASE_URL = 'https://content.staging.shamsuperstore.com';
// export const MEDIA_BASE_URL = 'https://content.staging.shamsuperstore.com';
// export const SELLER_DASH_URL = 'https://seller.staging.shamsuperstore.com';
// export const LOCATIONIQ_MAP_TILE_URL =
//   'https://{s}-tiles.locationiq.com/v3/streets/r/{z}/{x}/{y}.png?key=pk.69a3e3d691e39501b31834c3c7cffbb5';
